import { PageLayoutWidgetType } from "../../../generated/client";

/**
 * All widget types that can be used as content containers
 */
export const allowedContainerTypes = [
  PageLayoutWidgetType.FrameLayout,
  PageLayoutWidgetType.LinearLayout,
  PageLayoutWidgetType.RelativeLayout
];